import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EOpenNewQuestionForm } from './openFormActionsTypes';
import { ENewQuestionModalStep } from '../../types/newQuestion';
import { getNewQuestionFormStep } from '../../selectors/newQuestion';
import { setNewQuestionFormStep } from './stepActionsTypes';
import { clearNewQuestionFormAction } from './newQuestionAction';
import { ELabel, ETrackingAction, trackQuestionFormAction } from './tracking';

export const setNewQuestionFormOpenAction = actionGenerator<EOpenNewQuestionForm.Open>(EOpenNewQuestionForm.Open);
export const setNewQuestionFormCloseAction = actionGenerator<EOpenNewQuestionForm.Close>(EOpenNewQuestionForm.Close);

export function setNewQuestionFormOpen(): TThunkAction<Promise<void>> {
  return async dispatch => {
    dispatch(setNewQuestionFormOpenAction());
    trackQuestionFormAction(ETrackingAction.Show, ELabel.Form);
  };
}

export function setNewQuestionFormClose(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const step = getNewQuestionFormStep(state);

    if (step === ENewQuestionModalStep.Success) {
      dispatch(clearNewQuestionFormAction());
    }

    dispatch(setNewQuestionFormStep(ENewQuestionModalStep.Question));
    dispatch(setNewQuestionFormCloseAction());
  };
}
